// extracted by mini-css-extract-plugin
module.exports = {"header":"_3szEyeXqROgwhV8DAA1n7p","title":"v4MPc2YwIg57ny752RYuv","dialog":"_2HxnWJSmAkbJopeZXO0AmJ","role":"_1O-q3JjKGcdIalATzrkrao","right":"_2QlS4Jc5STHCWcIORNomA2"};